import { BrowserRouter, Redirect, Switch, Route } from 'react-router-dom'
import React from 'react'

import { constants } from './utils'
import { appService } from './services'

import LayoutBase from './components/Layout/LayoutBase'

import { ForgotPassword, Request } from './screens/RenewEnrollments'
import { Create, Search } from './screens/Subscriptions'

import {
  Home,
  Instructions,
  NotFound,
  PreEnrollmentCheck,
  WaitingList,
  RequestInclusion,
} from './screens'

const { routes } = constants

const ChooseFirst = () => (
  <BrowserRouter>
    <Switch>
      <Route exact path="/" render={() => <Home />} />
      <Route
        path="*"
        render={({ location }) => (
          <Redirect to={{ pathname: '/', state: { from: location.pathname } }} />
        )}
      />
    </Switch>
  </BrowserRouter>
)

const Router = ({ needsChoice = false }) => {
  const can = action => appService.getLocalPublicCall()[action]

  if (needsChoice) return <ChooseFirst />

  return (
    <BrowserRouter>
      <Switch>
        <Route exact path="/" render={() => <Home />} />

        {can('name') && (
          <Route
            exact
            path={routes.subscriptions.search.path}
            render={() => (
              <LayoutBase>
                <Search />
              </LayoutBase>
            )}
          />
        )}

        {can('subscribe') && (
          <Route
            exact
            path={routes.preEnrollmentCheck.path}
            render={() => (
              <LayoutBase>
                <PreEnrollmentCheck />
              </LayoutBase>
            )}
          />
        )}

        {can('subscribe') && (
          <Route
            exact
            path={routes.instructions.path}
            render={() => (
              <LayoutBase>
                <Instructions />
              </LayoutBase>
            )}
          />
        )}

        {can('subscribe') && (
          <Route
            exact
            path={routes.subscriptions.create.path}
            render={() => (
              <LayoutBase>
                <Create />
              </LayoutBase>
            )}
          />
        )}

        {can('subscribe') && (
          <Route
            exact
            path={routes.subscriptions.edit.path}
            render={() => (
              <LayoutBase>
                <Create />
              </LayoutBase>
            )}
          />
        )}

        <Route
          exact
          path={routes.waitingList.path}
          render={() => (
            <LayoutBase>
              <WaitingList />
            </LayoutBase>
          )}
        />

        {can('renew') && (
          <Route
            exact
            path={routes.renewEnrollments.request.path}
            render={() => (
              <LayoutBase>
                <Request />
              </LayoutBase>
            )}
          />
        )}

        {can('renew') && (
          <Route
            exact
            path={routes.renewEnrollments.forgotPassword.path}
            render={() => (
              <LayoutBase>
                <ForgotPassword />
              </LayoutBase>
            )}
          />
        )}

        <Route
          exact
          path={routes.subscriptions.search.path}
          render={() => (
            <LayoutBase>
              <Search />
            </LayoutBase>
          )}
        />

        <Route
          exact
          path={routes.renewEnrollments.request.path}
          render={() => (
            <LayoutBase>
              <Request />
            </LayoutBase>
          )}
        />

        <Route
          exact
          path={routes.renewEnrollments.forgotPassword.path}
          render={() => (
            <LayoutBase>
              <ForgotPassword />
            </LayoutBase>
          )}
        />

        <Route
          exact
          path={routes.waitingList.requestInclusion.path}
          render={() => (
            <LayoutBase>
              <RequestInclusion />
            </LayoutBase>
          )}
        />

        <Route path="*" render={() => <NotFound />} />
      </Switch>
    </BrowserRouter>
  )
}

export default Router
